import { createRegisterReplaceableComponents } from "@multiweb/reactCustomization";
import { FormMenuComponent } from "../components/FormMenuComponent";
import { MenuPanelComponent } from "../components/MenuPanelComponent";
import { NotificationListComponent } from "../components/NotificationListComponent";
import { QuickAccessMenuComponent } from "../components/QuickAccessMenuComponent";
import { SubmenuListComponent } from "../components/SubmenuListComponent";
import { UserMenuComponent } from "../components/UserMenuComponent";
import { ReplaceableComponentNames } from "./replaceableComponentNames";

/**
 * @internal
 */
export const defaultComponentMap = {
    [ReplaceableComponentNames.MenuPanelComponent]: MenuPanelComponent,
    [ReplaceableComponentNames.SubmenuListComponent]: SubmenuListComponent,
    [ReplaceableComponentNames.UserMenuComponent]: UserMenuComponent,
    [ReplaceableComponentNames.FormMenuComponent]: FormMenuComponent,
    [ReplaceableComponentNames.NotificationListComponent]: NotificationListComponent,
    [ReplaceableComponentNames.QuickAccessMenuComponent]: QuickAccessMenuComponent,
};

export const registerReplaceableComponents = createRegisterReplaceableComponents(defaultComponentMap);

export default { registerReplaceableComponents };
